import { render, staticRenderFns } from "./comp-1.vue?vue&type=template&id=1ecdb137&scoped=true"
import script from "./comp-1.vue?vue&type=script&lang=js"
export * from "./comp-1.vue?vue&type=script&lang=js"
import style0 from "./comp-1.vue?vue&type=style&index=0&id=1ecdb137&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecdb137",
  null
  
)

export default component.exports